// extracted by mini-css-extract-plugin
export default {"container":"Teammate_container__Y2Cmz","info":"Teammate_info__L5pVa"};